export const MAX_FILE_LENGTH = 5_000_000;

// List of commands we don't want to end up in the command palette
export const IGNORED_ACTIONS = new Set([
  "editor.action.toggleHighContrast",
  "editor.action.quickCommand",
]);
